import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { HeadingFormElement } from "../../../types";
import { FormElementChangeType } from "../FormBuilder";

export const HeadingSideSectionDisplay = ({
  element,
  onChange,
}: {
  element: HeadingFormElement;
  onChange: (props: FormElementChangeType) => void;
}) => {
  return (
    <FormControl>
      <FormLabel id="form-element-heading-visibility">Visibility</FormLabel>
      <FormGroup aria-labelledby="form-element-heading-visibility">
        <FormControlLabel
          control={<Checkbox checked={!element.hide} />}
          label={"Show Header"}
          onChange={(_, value) => {
            onChange({
              changeType: "update",
              newElement: {
                ...element,
                hide: !value,
              },
            });
          }}
        />
      </FormGroup>

      <FormGroup aria-labelledby="form-element-heading-visibility">
        <FormControlLabel
          control={<Checkbox checked={!element.hideInSummary} />}
          label={"Show Header In Summary"}
          onChange={(_, value) => {
            onChange({
              changeType: "update",
              newElement: {
                ...element,
                hideInSummary: !value,
              },
            });
          }}
        />
      </FormGroup>
    </FormControl>
  );
};
